/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 18:26:20
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 21:33:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorButton/Item/index.tsx
 */
import { ItemWrapper } from '@/src/components';
import { Checkbox, Input, Select } from '@/src/components/Antd';
import { SectionContainer } from '@/src/components/Layouts';
import { currentSelectedLanguage } from '@/src/constrains/SalesChannelMultiLanguageSelect/slice';
import { FONT_LIST, GENERIC_FONT } from '@/src/tools/constant';
import { Icon } from '@/src/tools/icon';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import Switcher from 'src/components/SectionSwitcher';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import FontStyleSetting from '../../Components/FontStyleSetting';
import { onChangeField, onChangeFont, onResetButtonProp } from '../slice';
import { ButtonType } from '../tool';
import styles from './style.less';
function Item(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [s, setS] = useState('regular');
  const { button, errorProcessingProps, isOnPrimaryLanguage } = props;
  const { specificError } = errorProcessingProps;
  const _d = useDispatch();
  const outlined = button?.type === ButtonType.OUTLINE_FILLED;
  const currentLanguage = useSelector(currentSelectedLanguage());
  return (
    <React.Fragment>
      {isOnPrimaryLanguage && (
        <SectionContainer bottomBorder size={'small'}>
          <ItemWrapper title={'Button Name*'}>
            <Input
              error={
                specificError['name'] && specificError['name'].length !== 0
              }
              help={specificError['name']}
              size={'large'}
              value={button.name}
              onChange={(value) => {
                _d(onChangeField({ uuid: button.uuid, path: 'name', value }));
              }}
            />
          </ItemWrapper>
          <ItemWrapper title={'Button Type'}>
            <Select
              size={'large'}
              value={button?.type}
              onChange={(value) => {
                _d(
                  onChangeField({
                    uuid: button.uuid,
                    path: 'type',
                    value,
                  }),
                );
                _d(onResetButtonProp({ uuid: button.uuid, value }));
              }}
              options={[
                { label: 'Outline & Filled', value: ButtonType.OUTLINE_FILLED },
                { label: 'Text', value: ButtonType.TEXT },
              ]}
            />
          </ItemWrapper>
          {outlined && (
            <>
              <Slider
                value={button?.paddingLeftRight}
                title={'Left & Right Padding'}
                customIcon={
                  <Icon
                    type={'icona-leftrightpadding'}
                    className={styles.icon}
                  />
                }
                onChange={(value) => {
                  _d(
                    onChangeField({
                      uuid: button.uuid,
                      path: 'paddingLeftRight',
                      value,
                    }),
                  );
                }}
                max={400}
                min={0}
              />
              <Slider
                value={button?.height}
                title={'Button Height'}
                customIcon={
                  <Icon type={'iconheight'} className={styles.icon} />
                }
                onChange={(value) => {
                  _d(
                    onChangeField({
                      uuid: button.uuid,
                      path: 'height',
                      value,
                    }),
                  );
                }}
                max={400}
                min={0}
              />
              <Slider
                value={button?.radius}
                title={'Radius'}
                customIcon={
                  <Icon type={'iconradious'} className={styles.icon} />
                }
                onChange={(value) => {
                  _d(
                    onChangeField({
                      uuid: button.uuid,
                      path: 'radius',
                      value,
                    }),
                  );
                }}
                max={400}
                min={0}
              />
              <Slider
                value={button?.outlineStrokeWidth}
                title={'Outline Stroke Width'}
                customIcon={
                  <Icon type={'iconoutline'} className={styles.icon} />
                }
                onChange={(value) => {
                  _d(
                    onChangeField({
                      uuid: button.uuid,
                      path: 'outlineStrokeWidth',
                      value,
                    }),
                  );
                }}
                max={400}
                min={0}
              />
            </>
          )}
        </SectionContainer>
      )}
      <SectionContainer size={'small'} className={styles.paddingBottom}>
        <Switcher
          selected={s}
          onChange={(v) => setS(v)}
          allSections={{
            regular: {
              title: 'Regular',
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={'Button Text Font'}>
                    <Select
                      size={'large'}
                      value={button?.regularStyle?.textFont}
                      options={
                        currentLanguage === 'zh-CN' ? GENERIC_FONT : FONT_LIST
                      }
                      onChange={(value) => {
                        _d(
                          onChangeField({
                            uuid: button.uuid,
                            path: 'regularStyle.textFont',
                            value,
                          }),
                        );
                      }}
                    />
                  </ItemWrapper>
                  <ItemWrapper title={'Font Size'}>
                    <div className={styles.flex}>
                      <Input
                        error={
                          specificError['regularStyle.fontSize'] &&
                          specificError['regularStyle.fontSize'].length !== 0
                        }
                        size={'large'}
                        value={button?.regularStyle?.fontSize}
                        suffix={'px'}
                        onChange={(value) => {
                          _d(
                            onChangeField({
                              uuid: button.uuid,
                              path: 'regularStyle.fontSize',
                              value,
                            }),
                          );
                        }}
                      />
                      <FontStyleSetting
                        value={{
                          bold: button?.regularStyle?.bold,
                          underline: button?.regularStyle?.underline,
                          italic: button?.regularStyle?.italic,
                        }}
                        onChange={(value) => {
                          _d(
                            onChangeFont({
                              uuid: button.uuid,
                              path: 'regularStyle',
                              value,
                            }),
                          );
                        }}
                      />
                    </div>
                  </ItemWrapper>
                  {isOnPrimaryLanguage && (
                    <>
                      <ItemWrapper title={getI18n('general.textColour')}>
                        <ColorPicker
                          multi
                          onChange={(value) => {
                            _d(
                              onChangeField({
                                uuid: button.uuid,
                                path: 'regularStyle.textColor',
                                value,
                              }),
                            );
                          }}
                          color={button?.regularStyle?.textColor}
                        />
                      </ItemWrapper>
                      {outlined && (
                        <>
                          <ItemWrapper title={'Outline Colour'}>
                            <ColorPicker
                              multi
                              onChange={(value) => {
                                _d(
                                  onChangeField({
                                    uuid: button.uuid,
                                    path: 'regularStyle.outlineColor',
                                    value,
                                  }),
                                );
                              }}
                              color={button?.regularStyle?.outlineColor}
                            />
                          </ItemWrapper>
                          <ItemWrapper title={'Filled Colour'}>
                            <ColorPicker
                              multi
                              onChange={(value) => {
                                _d(
                                  onChangeField({
                                    uuid: button.uuid,
                                    path: 'regularStyle.filledColor',
                                    value,
                                  }),
                                );
                              }}
                              color={button?.regularStyle?.filledColor}
                            />
                          </ItemWrapper>
                          <Checkbox
                            onChange={(value) => {
                              _d(
                                onChangeField({
                                  uuid: button.uuid,
                                  path: 'regularStyle.enableShadow',
                                  value,
                                }),
                              );
                            }}
                            checked={button?.regularStyle?.enableShadow}>
                            {'Enable Shadow'}
                          </Checkbox>
                          <SectionContainer
                            size={'small'}
                            className={styles.noLeftPadding}>
                            {button?.regularStyle?.enableShadow && (
                              <React.Fragment>
                                <ItemWrapper title={'Shadow Colour'}>
                                  <ColorPicker
                                    multi
                                    onChange={(value) => {
                                      _d(
                                        onChangeField({
                                          uuid: button.uuid,
                                          path: 'regularStyle.shadowStyle.shadowColor',
                                          value,
                                        }),
                                      );
                                    }}
                                    color={
                                      button?.regularStyle?.shadowStyle
                                        ?.shadowColor
                                    }
                                  />
                                </ItemWrapper>
                                <div className={styles.flex1}>
                                  <ItemWrapper title={'Blur'}>
                                    <Input
                                      error={
                                        specificError[
                                          'regularStyle.shadowStyle.blur'
                                        ] &&
                                        specificError[
                                          'regularStyle.shadowStyle.blur'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.regularStyle?.shadowStyle?.blur
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'regularStyle.shadowStyle.blur',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'Spread'}>
                                    <Input
                                      error={
                                        specificError[
                                          'regularStyle.shadowStyle.spread'
                                        ] &&
                                        specificError[
                                          'regularStyle.shadowStyle.spread'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.regularStyle?.shadowStyle
                                          ?.spread
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'regularStyle.shadowStyle.spread',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'X Offset'}>
                                    <Input
                                      error={
                                        specificError[
                                          'regularStyle.shadowStyle.xoffset'
                                        ] &&
                                        specificError[
                                          'regularStyle.shadowStyle.xoffset'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.regularStyle?.shadowStyle
                                          ?.xoffset
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'regularStyle.shadowStyle.xoffset',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'Y Offset'}>
                                    <Input
                                      error={
                                        specificError[
                                          'regularStyle.shadowStyle.yoffset'
                                        ] &&
                                        specificError[
                                          'regularStyle.shadowStyle.yoffset'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.regularStyle?.shadowStyle
                                          ?.yoffset
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'regularStyle.shadowStyle.yoffset',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                </div>
                              </React.Fragment>
                            )}
                          </SectionContainer>
                        </>
                      )}
                    </>
                  )}
                </React.Fragment>
              ),
            },
            hover: {
              title: 'Hover',
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={'Button Text Font'}>
                    <Select
                      size={'large'}
                      value={button?.hoverStyle?.textFont}
                      options={
                        currentLanguage === 'zh-CN' ? GENERIC_FONT : FONT_LIST
                      }
                      onChange={(value) => {
                        _d(
                          onChangeField({
                            uuid: button.uuid,
                            path: 'hoverStyle.textFont',
                            value,
                          }),
                        );
                      }}
                    />
                  </ItemWrapper>
                  <ItemWrapper title={'Font Size'}>
                    <div className={styles.flex}>
                      <Input
                        error={
                          specificError['hoverStyle.fontSize'] &&
                          specificError['hoverStyle.fontSize'].length !== 0
                        }
                        size={'large'}
                        value={button?.hoverStyle?.fontSize}
                        suffix={'px'}
                        onChange={(value) => {
                          _d(
                            onChangeField({
                              uuid: button.uuid,
                              path: 'hoverStyle.fontSize',
                              value,
                            }),
                          );
                        }}
                      />
                      <FontStyleSetting
                        value={{
                          bold: button?.hoverStyle?.bold,
                          underline: button?.hoverStyle?.underline,
                          italic: button?.hoverStyle?.italic,
                        }}
                        onChange={(value) =>
                          _d(
                            onChangeFont({
                              uuid: button.uuid,
                              path: 'hoverStyle',
                              value,
                            }),
                          )
                        }
                      />
                    </div>
                  </ItemWrapper>
                  {isOnPrimaryLanguage && (
                    <>
                      <ItemWrapper title={getI18n('general.textColour')}>
                        <ColorPicker
                          multi
                          onChange={(value) => {
                            _d(
                              onChangeField({
                                uuid: button.uuid,
                                path: 'hoverStyle.textColor',
                                value,
                              }),
                            );
                          }}
                          color={button?.hoverStyle?.textColor}
                        />
                      </ItemWrapper>
                      {outlined && (
                        <>
                          <ItemWrapper title={'Outline Colour'}>
                            <ColorPicker
                              multi
                              onChange={(value) => {
                                _d(
                                  onChangeField({
                                    uuid: button.uuid,
                                    path: 'hoverStyle.outlineColor',
                                    value,
                                  }),
                                );
                              }}
                              color={button?.hoverStyle?.outlineColor}
                            />
                          </ItemWrapper>
                          <ItemWrapper title={'Filled Colour'}>
                            <ColorPicker
                              multi
                              onChange={(value) => {
                                _d(
                                  onChangeField({
                                    uuid: button.uuid,
                                    path: 'hoverStyle.filledColor',
                                    value,
                                  }),
                                );
                              }}
                              color={button?.hoverStyle?.filledColor}
                            />
                          </ItemWrapper>
                          <Checkbox
                            onChange={(value) => {
                              _d(
                                onChangeField({
                                  uuid: button.uuid,
                                  path: 'hoverStyle.enableShadow',
                                  value,
                                }),
                              );
                            }}
                            checked={button?.hoverStyle?.enableShadow}>
                            {'Enable Shadow'}
                          </Checkbox>
                          <SectionContainer
                            size={'small'}
                            className={styles.noLeftPadding}>
                            {button?.hoverStyle?.enableShadow && (
                              <React.Fragment>
                                <ItemWrapper title={'Shadow Colour'}>
                                  <ColorPicker
                                    multi
                                    onChange={(value) => {
                                      _d(
                                        onChangeField({
                                          uuid: button.uuid,
                                          path: 'hoverStyle.shadowStyle.shadowColor',
                                          value,
                                        }),
                                      );
                                    }}
                                    color={
                                      button?.hoverStyle?.shadowStyle
                                        ?.shadowColor
                                    }
                                  />
                                </ItemWrapper>
                                <div className={styles.flex1}>
                                  <ItemWrapper title={'Blur'}>
                                    <Input
                                      error={
                                        specificError[
                                          'hoverStyle.shadowStyle.blur'
                                        ] &&
                                        specificError[
                                          'hoverStyle.shadowStyle.blur'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.hoverStyle?.shadowStyle?.blur
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'hoverStyle.shadowStyle.blur',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'Spread'}>
                                    <Input
                                      error={
                                        specificError[
                                          'hoverStyle.shadowStyle.spread'
                                        ] &&
                                        specificError[
                                          'hoverStyle.shadowStyle.spread'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.hoverStyle?.shadowStyle?.spread
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'hoverStyle.shadowStyle.spread',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'X Offset'}>
                                    <Input
                                      error={
                                        specificError[
                                          'hoverStyle.shadowStyle.xoffset'
                                        ] &&
                                        specificError[
                                          'hoverStyle.shadowStyle.xoffset'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.hoverStyle?.shadowStyle?.xoffset
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'hoverStyle.shadowStyle.xoffset',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                  <ItemWrapper title={'Y Offset'}>
                                    <Input
                                      error={
                                        specificError[
                                          'hoverStyle.shadowStyle.yoffset'
                                        ] &&
                                        specificError[
                                          'hoverStyle.shadowStyle.yoffset'
                                        ].length !== 0
                                      }
                                      size={'large'}
                                      value={
                                        button?.hoverStyle?.shadowStyle?.yoffset
                                      }
                                      onChange={(value) => {
                                        _d(
                                          onChangeField({
                                            uuid: button.uuid,
                                            path: 'hoverStyle.shadowStyle.yoffset',
                                            value,
                                          }),
                                        );
                                      }}
                                      suffix={'px'}
                                    />
                                  </ItemWrapper>
                                </div>
                              </React.Fragment>
                            )}
                          </SectionContainer>
                        </>
                      )}
                    </>
                  )}
                </React.Fragment>
              ),
            },
          }}
        />
      </SectionContainer>
    </React.Fragment>
  );
}

export default Item;
